import * as React from 'react';
import Typography from '@material-ui/core/Typography';

const CustomTypography = (props) => {
    return <Typography {...props} />;
};

export { CustomTypography as Typography };
